import React from 'react';
import { Link } from 'react-router-dom';

import ImgBg from './img/solid-blue-1.jpg';
import profile1 from './img/poli-profile.png';

import './css/styles.css'

class NavBarLateral extends React.Component {

    render() {

        return (
            <ul className="sidenav sidenav-fixed">
                <li>
                    <div className="user-view">
                        <div className="background">
                            <img src={ImgBg} />
                        </div>
                        <a><img className="circle" src={profile1} /></a>
                        <a><span className="white-text name">Politécnico Gran Colombiano</span></a>
                        <a><span className="white-text email">Unidad Investigacion Periodística</span></a>
                    </div>
                </li>
                <div className="container_admin_section">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="Inicio">
                    </span>
                    <div>
                        <Link to={{
                            pathname: "/administrador/banner/actualizar/1",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Imagenes Carousel - 1
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/banner/actualizar/2",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Imagenes Carousel - 2
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/banner/actualizar/3",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Imagenes Carousel - 3
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/instragram/link/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Link Instagram
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/twitter/link/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Link Twitter
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/youtube/link/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Link Youtube
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/imagen/central/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Imagen Central
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/youtube/card/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Card Youtube
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/director/datos/actualizar",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Director Datos
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <div className="container_admin_section">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="Especiales">
                    </span>
                    <div>
                        <Link to={{
                            pathname: "/administrador/especiales",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Especiales
                                </a>
                            </li>
                        </Link>
                        <Link to={{
                            pathname: "/administrador/publicaciones",
                        }}>
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Publicaciones
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <div className="container_admin_section">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="Publicaciones">
                    </span>
                    <div>
                        <Link to="/administrador/publicaciones/principal">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Publicaciones
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <div className="container_admin_section">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="La Unidad">
                    </span>
                    <div>
                        <Link to="/administrador/equipo/card/youtube">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Card Youtube
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Equipo
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/director">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Director
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/que/somos/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Que Somos 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/que/somos/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Que Somos 2
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/que/hacemos/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Que Hacemos 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/que/hacemos/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Que Hacemos 2
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/como/lo/hacemos/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Como lo Hacemos 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/como/lo/hacemos/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Como lo Hacemos 2
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/equipo/imagen">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Imagen Equipo
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <div className="container_admin_section">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="Nos Hizo Feliz">
                    </span>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/titulo/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 1 - Titulo
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/1/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 1 - Img 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/1/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 1 - Img 2
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/titulo/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 2 - Titulo
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/2/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 2 - Img 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/2/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 2 - Img 2
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/titulo/3">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 3 - Titulo
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/3/1">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 3 - Img 1
                                </a>
                            </li>
                        </Link>
                    </div>
                    <div>
                        <Link to="/administrador/nos/hizo/feliz/img/3/2">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">navigate_next</i>
                                    Sección 3 - Img 2
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <div className="container_admin_section_last">
                    <span 
                        className="new badge blue badge_admin_section" 
                        data-badge-caption="Salir">
                    </span>
                    <div>
                        <Link to="/administrador/login">
                            <li>
                                <a className="waves-effect">
                                    <i className="material-icons left">account_box</i>
                                    Logout
                                </a>
                            </li>
                        </Link>
                    </div>
                </div>
                <li><div className="divider blue"></div></li>
                <li><div className="divider blue"></div></li>
                <li><div className="divider blue"></div></li>
            </ul>
        );
    }
}

export default NavBarLateral;